import { Injectable, ErrorHandler } from "@angular/core";

@Injectable()
export class AppErrorHandler extends ErrorHandler {
    constructor() {
        super();
    }


    override handleError(error: Error) {
        if (confirm("Fel!\nEtt ohanterat fel har inträffat. Vill du ladda om sidan?\n\nFeltext: " + error.message)) {
            window.location.reload();
        }

        super.handleError(error);
    }
}
